import { StopOrderControls } from "../hooks/useStopOrderControls";
import { StopOrderActions } from "./StopOrderActions";

interface Props {
  stopOrder: StopOrderControls;
  index: number;
}

/** The Move up / Move down / Insert stop below buttons for one stop row, when they are on. */
export function StopOrderRowControls({ stopOrder, index }: Props) {
  if (!stopOrder.isEnabled) return null;
  return (
    <StopOrderActions
      actions={stopOrder.getActions(index)}
      onMoveUp={() => stopOrder.moveStopUp(index)}
      onMoveDown={() => stopOrder.moveStopDown(index)}
      onInsertBelow={() => stopOrder.insertStopBelow(index)}
    />
  );
}
